import React, { Fragment, useState } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ConfirmationModal } from "../../../../layout/Modal/ConfirmationModal";
import { updateOrganizationKioskAccess } from "../../../../../api/clients/kiosk";
import {
  KIOSK_ACCESS_STATUSES,
  ORGANIZATION_STATUSES,
  TRANSLATED_KIOSK_ACCESS_STATUSES,
} from "../../../../../config/constants";
import { NOTIFICATION_ARCHIVE_SERVICE_ACTIONS } from '../../../../../config/notifications';
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';

function ToggleKioskAccess(props) {
  const [ showToggleModal, setShowToggleModal ] = useState( false );
  const { organization, index, actionCallback } = props;
  const kioskStatus = Number(organization?.local_kiosk_setting?.status) === KIOSK_ACCESS_STATUSES.ENABLED ?
    KIOSK_ACCESS_STATUSES.ENABLED :
    KIOSK_ACCESS_STATUSES.DISABLED;
  const isEnabled = kioskStatus === KIOSK_ACCESS_STATUSES.ENABLED;
  const tooltipId = `toggle-kiosk-access-${index}`;

  const toggleKioskAccess = () => {
    const nextStatus = isEnabled ? KIOSK_ACCESS_STATUSES.DISABLED : KIOSK_ACCESS_STATUSES.ENABLED;

    updateOrganizationKioskAccess( {
      organizationId: organization.id,
      data: {
        status: nextStatus,
      },
      notificationId: NOTIFICATION_ARCHIVE_SERVICE_ACTIONS
    } ).then( (response) => {
      setShowToggleModal( false );

      if (response && ! response.status) {
        actionCallback();
      }
    } );
  };

  if (! organization?.id || organization?.status !== ORGANIZATION_STATUSES.CREATED) {
    return null;
  }

  return (
    <Fragment>
      <div className="d-flex align-items-center">
        <span className="mr-2">
          {TRANSLATED_KIOSK_ACCESS_STATUSES[kioskStatus]}
        </span>
        <span id={tooltipId}>
          <label className="custom-toggle kiosk-access-toggle mb-0">
            <input
              type="checkbox"
              name="enable_disable_kiosk_access"
              checked={isEnabled}
              onChange={() => {
                store.dispatch(hideNotification());
                setShowToggleModal( true );
              }}
            />
            <span className="custom-toggle-slider rounded-circle" />
          </label>
        </span>
      </div>
      <UncontrolledTooltip
        delay={0}
        target={tooltipId}
        modifiers={{
          preventOverflow: {
            enabled: true,
            boundariesElement: "body",
          },
        }}
      >
        <FormattedMessage
          id={isEnabled ?
            "components.pages.organizations.table.actionButtons.disable_kiosk_access" :
            "components.pages.organizations.table.actionButtons.enable_kiosk_access"
          }
        />
      </UncontrolledTooltip>
      <ConfirmationModal
        showModal={showToggleModal}
        closeModal={() => setShowToggleModal( false )}
        confirmationYes={toggleKioskAccess}
        messageId={isEnabled ?
          "components.layout.confirmation.body.disable_kiosk_access" :
          "components.layout.confirmation.body.enable_kiosk_access"
        }
      />
    </Fragment>
  );
}

ToggleKioskAccess.defaultProps = {
  index: 0,
  organization: null,
  actionCallback: () => {},
};

export { ToggleKioskAccess };
